/**
 *
 * @module graphQlPersistedQuery
 *
 */

import Check from 'check-types';
import queryString from 'query-string';
import HttpMethod from './../configuration/httpMethod';
import GraphQlBuilder from './graphQlBuilder';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    includes,
    nonEmptyString,
    object
} = Check.assert;

/**
 *
 * @class GraphQlPersistedQuery
 * @extends {GraphQlBuilder}
 *
 */
export default class GraphQlPersistedQuery extends GraphQlBuilder {

    /**
     *
     * @param {String} queryId
     * @param {Object} [variables=null]
     *
     */
    constructor(queryId, variables = null) {

        const errorMessage = {
            ctor: 'GraphQlPersistedQuery(queryId, variables)',
            get queryId() {
                return `${this.ctor} queryId should be a String with length`;
            },
            get variables() {
                return `${this.ctor} variables needs instance of Object`;
            }
        };

        nonEmptyString(queryId, errorMessage.queryId, InvalidArgumentException);

        if (Check.assigned(variables)) {
            object(variables, errorMessage.variables, InvalidArgumentException);
        }

        super();

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.queryId = queryId;

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.variables = variables || {};

    }

    /**
     *
     * @access private
     * @param {String} url - The URL for which to build the query.
     * @param {HttpMethod} method - The method for which to build the query.
     * @desc Returns the URL for the query.
     * @returns {String} The URL for the query.
     *
     */
    createQueryUrl(url, method) {

        const errorMessage = {
            mthd: 'createQueryUrl(url, metho:',
            get url() {
                return `${this.mthd} url should be a String with length`;
            },
            get method() {
                return `${this.mthd} method needs a valid HttpMethod value`;
            }
        };

        nonEmptyString(url, errorMessage.url, InvalidArgumentException);

        includes(
            HttpMethod,
            method,
            errorMessage.method,
            InvalidArgumentException
        );

        const { queryId, variables } = this;

        let queryUrl = url.replace(/\{queryId\}/, queryId || '');

        if (method === HttpMethod.GET && Check.nonEmptyObject(variables)) {

            const queryStringParams = {
                variables: JSON.stringify(variables)
            };

            const urlQueryString = queryString.stringify(queryStringParams);

            queryUrl += `?${urlQueryString}`;

        }

        return queryUrl;

    }

    /**
     *
     * @access private
     * @desc Returns the post content for the query.
     * @returns {String} The post content for the query.
     *
     */
    createPostContent() {

        const { queryId, variables } = this;

        return JSON.stringify({
            id: queryId,
            variables
        });

    }

}



// WEBPACK FOOTER //
// ./src/services/content/graphQlPersistedQuery.js